/** fetch / apiRequest 在 AbortSignal 触发时的错误 */
export function isAbortError(e: unknown): boolean {
  return e instanceof DOMException && e.name === 'AbortError'
}
